import { Flex, Space, Typography } from "antd"
import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"

import ButtonComponent from "../../../../../Components/Button"
import { titleSortFilters } from "../../../../../Components/titleSortFilters"
import Icon from "../../../../../Icon"
import { alertsColumnIconMap, dateFormat } from "../../../../../Utils/utils"
import StatusTag from "../StatusTag/StatusTag"

import styles from "./columns.module.less"

dayjs.extend(utc)

const { Text } = Typography

export const getColumns = ({ onSelectRow, handleChangeStatus }) => ({
  status: {
    key: "status",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: "Status",
        sorter: true,
        icon: alertsColumnIconMap["status"],
        stateData: state,
        key: "status"
      }),
    dataIndex: "status",
    width: 150,
    maxWidth: 150,
    fixed: "left",
    render: (status, record) => {
      if (!status) return "—"
      return (
        <StatusTag
          status={status}
          onChange={async ({ status, rejectReason }) =>
            handleChangeStatus(record.id, { status, rejectReason })
          }
        />
      )
    }
  },
  created: {
    key: "created",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: "Request date",
        sorter: true,
        icon: alertsColumnIconMap["created_timestamp"],
        stateData: state,
        key: "created"
      }),
    dataIndex: "created",
    width: 185,
    render: (_) =>
      _ ? (
        <Space direction="vertical" size={4}>
          <Text>{dayjs(_).format(dateFormat)}</Text>
          <Text type="secondary">{dayjs(_).format("h:mm A [(UTC)]")}</Text>
        </Space>
      ) : (
        "—"
      )
  },
  updated: {
    key: "updated",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: "Update status date",
        sorter: true,
        icon: alertsColumnIconMap["created_timestamp"],
        stateData: state,
        key: "updated"
      }),
    dataIndex: "updated",
    width: 200,
    render: (_) =>
      _ ? (
        <Space direction="vertical" size={4}>
          <Text>{dayjs(_).format(dateFormat)}</Text>
          <Text type="secondary">{dayjs(_).format("h:mm A [(UTC)]")}</Text>
        </Space>
      ) : (
        "—"
      )
  },
  ba_name: {
    key: "ba_name",
    sorter: false,
    title: (state) =>
      titleSortFilters({
        title: "Business account",
        sorter: false,
        icon: alertsColumnIconMap["business_account"],
        stateData: state,
        key: "ba_name"
      }),
    dataIndex: "business_account",
    ellipsis: true,
    width: 200,
    render: (businessAccount, record) =>
      businessAccount?.name ? (
        <Flex
          gap={4}
          style={{ cursor: "pointer" }}
          onClick={(e) => {
            e.stopPropagation()
            onSelectRow(record, "business_account")
          }}
        >
          <Text
            style={{ color: "#225AEA" }}
            copyable={{
              icon: <Icon type="copy" />,
              tooltips: false,
              text: businessAccount.name,
              onCopy: (e) => e?.stopPropagation?.()
            }}
            strong
          >
            {businessAccount.name}
          </Text>
        </Flex>
      ) : (
        "—"
      )
  },
  user_name: {
    key: "user_name",
    title: (state) =>
      titleSortFilters({
        title: "User name",
        icon: alertsColumnIconMap["user_full_name"],
        stateData: state,
        key: "user_name"
      }),
    dataIndex: "user_name",
    width: 185
  }
})

export const getDefaultColumn = ({ field_id, label }) => ({
  key: field_id,
  title: (state) =>
    titleSortFilters({
      title: label,
      icon: alertsColumnIconMap[field_id],
      stateData: state,
      key: field_id
    }),
  dataIndex: field_id,
  width: 200,
  render: (value) => <Text>{value || "—"}</Text>
})

export const getActionColumn = ({ onSelectRow }) => ({
  key: "actions",
  fixed: "right",
  title: (state) =>
    titleSortFilters({
      title: "",
      sorter: false,
      stateData: state,
      key: "actions"
    }),
  className: styles.actionColumn,
  width: 52,
  render: (_, record) => {
    const handleAction = (e, data, type) => {
      e.preventDefault()
      e.stopPropagation()
      onSelectRow(data, type)
    }
    return (
      <Flex gap={4}>
        <ButtonComponent
          icon={<Icon type="eye" className={styles.actionIcon} />}
          onClick={(e) => handleAction(e, record, "view_request")}
          className={styles.actionButton}
        />
      </Flex>
    )
  }
})
